import { Patient } from '@/core/models/patient.model'
import { InsIdentity } from '@/core/types/dmp-connect'
import { isInsBirthGivenPrefixAllowed } from '@/features/patient/patient-profile-form/lib/identity-naming'

type PatientInsNames = Pick<Patient['userInfo'], 'birthFirstName'>
type InsiIdentityNames = Pick<InsIdentity, 's_birthName' | 's_birthGiven' | 's_birthPlace'>
type MergeInsiIdentityResult =
  | { success: true; userInfo: Patient['userInfo'] }
  | { success: false; error: 'birthFirstNameMismatch' }

export function getInsSearchGivenCandidates({ birthFirstName }: PatientInsNames): string[] {
  const normalizedBirthFirstName = birthFirstName?.trim()
  if (!normalizedBirthFirstName) return []

  const candidates = normalizedBirthFirstName.split(/\s+/)
  return candidates.length > 1 ? [...candidates, normalizedBirthFirstName] : candidates
}

export function mergeInsiIdentityWithLocalBirthFirstName(
  userInfo: Patient['userInfo'],
  identity: InsiIdentityNames
): MergeInsiIdentityResult {
  const birthFirstName = userInfo.birthFirstName?.trim()
  if (!birthFirstName || !isInsBirthGivenPrefixAllowed(identity.s_birthGiven, birthFirstName)) {
    return { success: false, error: 'birthFirstNameMismatch' }
  }

  return {
    success: true,
    userInfo: {
      ...userInfo,
      birthSurname: identity.s_birthName,
      birthName: identity.s_birthGiven,
      birthFirstName,
      birthPlaceCode: identity.s_birthPlace,
    },
  }
}
